<div class="p-4" [formGroup]="messageForm">
  <div class="field mb-4">
    <div class="flex align-items-center gap-2 mb-3">
      <p-checkbox formControlName="sendToAll" [binary]="true" inputId="sendToAll"></p-checkbox>
      <label for="sendToAll">{{ 'messages.create.sendToAll' | translate }}</label>
    </div>

    <div *ngIf="!messageForm.get('sendToAll')?.value">
      <label class="block mb-2"
        >{{ 'messages.create.recipients' | translate }}<span class="text-red-500">*</span></label
      >
      <p-multiSelect
        formControlName="recipient"
        [options]="availableRecipients"
        optionLabel="name"
        optionValue="code"
        [filter]="true"
        [showToggleAll]="true"
        [maxSelectedLabels]="100"
        display="chip"
        [placeholder]="'messages.create.recipients.placeholder' | translate"
        class="w-full multiselect-custom"
        [panelStyle]="{ 'min-width': '100%' }"
        [class.ng-invalid]="messageForm.get('recipient')?.invalid && messageForm.get('recipient')?.touched"
      ></p-multiSelect>
      <rqa-validator [control]="messageForm.get('recipient')"></rqa-validator>
    </div>
  </div>

  <div class="field mb-4">
    <label for="title" class="block mb-2"
      >{{ 'messages.create.subject' | translate }}<span class="text-red-500">*</span></label
    >
    <input
      type="text"
      pInputText
      id="title"
      formControlName="title"
      class="w-full"
      [class.ng-invalid]="messageForm.get('title')?.invalid && messageForm.get('title')?.touched"
    />
    <rqa-validator [control]="messageForm.get('title')"></rqa-validator>
  </div>

  <div class="field mb-4">
    <label for="content" class="block mb-2"
      >{{ 'messages.create.content' | translate }}<span class="text-red-500">*</span></label
    >
    <p-editor
      formControlName="content"
      [style]="{ height: '320px' }"
      [placeholder]="'messages.create.content.placeholder' | translate"
      [class.ng-invalid]="messageForm.get('content')?.invalid && messageForm.get('content')?.touched"
    ></p-editor>
    <rqa-validator [control]="messageForm.get('content')"></rqa-validator>
  </div>

  <div class="flex justify-content-end gap-2">
    <button
      pButton
      type="button"
      [label]="'primeng.cancel' | translate"
      class="p-button-outlined"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      [label]="'messages.create.send' | translate"
      (click)="send()"
      [disabled]="!isFormValid"
    ></button>
  </div>
</div>
